import { Box } from "@mui/material";
import { HeaderSideBarContent } from "common";
import CopyRight from "components/CopyRight/CopyRight";
import { Outlet } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminSidebarMenu from "./AdminSidebarMenu";

export default function AdminLayout() {
  return (
    <HeaderSideBarContent
      drawerProps={{
        sx: {
          [`& div.MuiDrawer-paper`]: {
            borderRight: "none",
            background: "none",
          },
        },
      }}
      conetentProps={{
        sx: {
          //backgroundColor: "background.paper",
          height: "fit-content",
          minHeight: "100%",
        },
      }}
      header={<AdminHeader />}
      fixHeader
      //breadcrumbs={<Breadcrumbs items={getMenu(true)} />}
      sidebar={<AdminSidebarMenu />}
      closedWidth={64}
      sidebarWidth={260}
      footer={
        <Box sx={{ p: 1 }}>
          <CopyRight />
        </Box>
      }
    >
      <Box
        sx={{
          //padding: 3,
          borderRadius: 1,
          //backgroundColor: "background.paper",
        }}
      >
        <Outlet />
      </Box>
    </HeaderSideBarContent>
  );
}
